<nz-spin [nzSpinning]="isLoading">
    <div class="container">
        <div class="page-header">
            <div>
                <p class="eyebrow">Processing Fees</p>
                <h2>Processing Fee Queue</h2>
                <p class="subtitle">Filter by fee date, take action on overdue items, or export a CSV for follow-up.</p>
            </div>
            <div class="header-actions">
                <button nz-button nzShape="round" nzType="default" (click)="getData()" [disabled]="isLoading">
                    <i nz-icon nzType="reload"></i>
                    Refresh
                </button>
                <button nz-button nzShape="round" nzType="primary" (click)="downloadCsv()">
                    <i nz-icon nzType="download"></i>
                    Export CSV
                </button>
            </div>
        </div>

        <div class="filter-card">
            <div class="filter-group">
                <label>Fee date range</label>
                <nz-range-picker nzSize="large" [(ngModel)]="feeDateRange" (ngModelChange)="onDateRangeChange($event)"
                    nzAllowClear nzFormat="MM/dd/yyyy" [nzPlaceHolder]="['Start date', 'End date']"></nz-range-picker>
            </div>
            <div class="filter-actions">
                <button nz-button nzType="default" (click)="clearFilters()">
                    Clear filter
                </button>
                <span class="pill">Showing {{ processingFees.length }} fees</span>
            </div>
        </div>

        <nz-table #basicTable [nzData]="processingFees" [nzFrontPagination]="false" [nzTotal]="total" nzBordered
            [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
            <thead>
                <tr>
                    <th>Customer</th>
                    <th>Processing Fee</th>
                    <th>Fee Date</th>
                    <th>Last Attempt</th>
                    <th>Action</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let lead of processingFees">
                    <td>{{ lead.first_name | titlecase }} {{ lead.last_name | titlecase }}</td>
                    <td>{{ lead.processing_fee }}</td>
                    <td>{{ lead.processing_fee_date | date: 'mediumDate' }}</td>

                    <td>
                        <ng-container *ngIf="lead?.attempts?.length as len; else noAttempt">
                            <ng-container *ngIf="len > 0">
                                <span>{{ lead.attempts[len - 1]?.result || 'unknown' | titlecase }} - {{(lead.attempts[len -
                                    1]?.dateAttempted | date: 'M/d, h:mm a') || ''}} by {{(lead.attempts[len - 1]?.repName || 'Unknown') | titlecase}} </span>
                            </ng-container>
                        </ng-container>
                        <ng-template #noAttempt>—</ng-template>
                    </td>

                    <td>
                        <a (click)="showEditModal(lead)" style="margin-right: 12px;">Edit</a>
                        <a (click)="showChargeModal(lead)" style="margin-right: 12px;">Charge</a>
                        <a (click)="showWaiveModal(lead)">Waive</a>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>

<nz-modal [(nzVisible)]="editOpen" nzTitle="Edit Processing Fee" (nzOnCancel)="closeEdit()" [nzFooter]="editFooter">
    <ng-container *nzModalContent>
        <div *ngIf="selected">
            <div style="margin-bottom: 12px;">
                <div><strong>Customer:</strong> {{ selected.first_name | titlecase }} {{ selected.last_name | titlecase
                    }}</div>
                <div class="fee-options">
                    <span class="fee-options__label">Processing Fee:</span>
                    <button nz-button nzSize="small" nzShape="round" [nzType]="isFeeSelected(49.99) ? 'primary' : 'default'"
                        (click)="setFee(49.99)">$49.99</button>
                    <button nz-button nzSize="small" nzShape="round" [nzType]="isFeeSelected(24.99) ? 'primary' : 'default'"
                        (click)="setFee(24.99)">$24.99</button>
                    <button nz-button nzSize="small" nzShape="round" [nzType]="isFeeSelected(0) ? 'primary' : 'default'"
                        (click)="setFee(0)">$0.00</button>
                    <span class="fee-selected">Selected: {{ editedProcessingFee || '$0.00' }}</span>
                </div>
                <div><strong>Fee Date:</strong> {{ selected.processing_fee_date | date: 'mediumDate' }}</div>
            </div>
        </div>
    </ng-container>
    <ng-template #editFooter>
        <button nz-button nzType="default" (click)="closeEdit()" [disabled]="isLoading">Cancel</button>
        <button nz-button nzType="primary" (click)="saveFeeOnly()" [disabled]="isLoading">Update Fee</button>
    </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="chargeOpen" nzTitle="Charge Processing Fee" (nzOnCancel)="closeCharge()"
    [nzFooter]="chargeFooter">
    <ng-container *nzModalContent>
        <div *ngIf="selected">
            <div style="margin-bottom: 12px;">
                <div><strong>Customer:</strong> {{ selected.first_name | titlecase }} {{ selected.last_name | titlecase
                    }}</div>
                <div><strong>Processing Fee:</strong> {{ editedProcessingFee || selected.processing_fee || '$0.00' }}</div>
                <div><strong>Fee Date:</strong> {{ selected.processing_fee_date | date: 'mediumDate' }}</div>
            </div>

            <!-- Card selection -->
            <div *ngIf="(cardOptions?.length || 0) > 0; else noSavedCards" style="margin-bottom: 12px;">
                <div style="margin-bottom: 6px;"><strong>Select Card:</strong></div>
                <nz-radio-group [(ngModel)]="selectedCardId" (ngModelChange)="onCardSelection($event)">
                    <label nz-radio *ngFor="let card of cardOptions" [nzValue]="card.authorizePaymentId">
                        Card ending {{ card.cardLast4 || '••••' }}
                    </label>
                </nz-radio-group>
            </div>
            <ng-template #noSavedCards>
                <div *ngIf="selectedCardId; else noCardsAvailable" style="margin-bottom: 12px;">
                    <strong>Payment Profile:</strong> {{ selectedCardId }}
                </div>
            </ng-template>
            <ng-template #noCardsAvailable>
                <div style="margin-bottom: 12px;">No saved cards found for this customer.</div>
            </ng-template>

            <hr />

            <!-- Attempt History -->
            <div *ngIf="selected?.attempts?.length" style="margin-top: 8px;">
                <div style="margin-bottom: 6px;"><strong>Attempt History</strong></div>
                <ul style="margin:0; padding-left: 18px;">
                    <li *ngFor="let a of selected.attempts">
                        {{ a?.dateAttempted | date: 'M/d, y, h:mm a' }} — {{ a?.result || 'unknown' }} by {{(a?.repName || 'unkown') | titlecase}}
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>
    <ng-template #chargeFooter>
        <button nz-button nzType="default" (click)="closeCharge()" [disabled]="isLoading">Cancel</button>
        <button nz-button nzType="primary" (click)="confirmCharge()" [disabled]="isLoading">Charge</button>
    </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="waiveOpen" nzTitle="Waive Processing Fee" nzOkText="Confirm Waive" nzOkDanger="true"
    (nzOnCancel)="closeWaive()" (nzOnOk)="submitWaive()">
    <ng-container *nzModalContent>
        <div *ngIf="selected">
            <div style="margin-bottom: 12px;">
                <p><strong>Are you sure you want to waive this processing fee?</strong></p>
                <div><strong>Customer:</strong> {{ selected.first_name | titlecase }} {{ selected.last_name | titlecase
                    }}</div>
                <div><strong>Processing Fee:</strong> {{ selected.processing_fee }}</div>
                <div><strong>Fee Date:</strong> {{ selected.processing_fee_date | date: 'mediumDate' }}</div>
            </div>
            <p style="color: #ff4d4f; margin-top: 12px;">This action will set the processing fee to $0.00 and mark the order as waived.</p>
        </div>
    </ng-container>
</nz-modal>
